define([
	"dojo/_base/declare",
	"csi",
	"csi/heading/Boolean"
], function(declare,csi,BooleanRen) {

	return declare(BooleanRen, {
		bBaseRenderer: true,
		defaultValue: csi.EMPTY_URL,
		tagAction: "ActionBooleanRef",

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: restrict filtering for heading
			return null;
		},

		_getCSS: function(/*String*/type, /*String?*/format) {
			return "attrBoolean";
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return csi.heading.ActionData for rendering with any settings from heading; note that the
			// action is shared - a new action is not created
			var b = ctx.isReadOnly();
			ctx.setReadOnly(false);
			var a = this.inherited(arguments);
			ctx.setReadOnly(b);
			return a;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return true if ref at given index points to current ref
			return this.inherited(arguments) == ctx.getNodeContextURL();
		}
	});
});